import * as R from "ramda";
import { call, reducer } from "../../helpers/api/meta";
import { getClassRoomTopics } from "../../helpers/api/api";

export const GET_CLASSEROOM_TOPICS = "GET_CLASSEROOM_TOPICS";
export const callGetClassRoomTopics = (inputs) => {
  const meta = {
    endpoint: (params) => getClassRoomTopics(params),
    inputs,
    action: GET_CLASSEROOM_TOPICS,
    messages: {
      id: "getClasseRoomTopics",
      failure: "Could not get ClassRoom Topics.",
    },
  };
  return call(meta);
};

const initialState = {
  loading: false,
  result: [],
};

const messages = {
  loadFailed: "Could not load classroom topics.",
};

const saveClasseRoomTopics = (state, action) => {
  return R.assoc("result", action.result, state);
};

export default reducer(
  initialState,
  GET_CLASSEROOM_TOPICS,
  saveClasseRoomTopics,
  messages.loadFailed
);
